export default "__VITE_ASSET__BsVI4DFD__"